import { StatusBar, Style } from "@capacitor/status-bar";
import { iosOrAndroid } from "@/lib/utils/config";

export const setStatusBarStyle = async (): Promise<void> => {
  if (iosOrAndroid) {
    await StatusBar.setStyle({ style: Style.Light });
    await StatusBar.setBackgroundColor({ color: "#f5ae45" });
  }
};
